import * as React from 'react';
export const bankLightningSvg = React.forwardRef(function bankLightningSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D8DEE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#474E5A',
      fillRule: 'evenodd',
      d: 'M24.251 11.671c.458.243.632.81.39 1.268l-2.084 3.936h1.675c.941 0 1.545 1 1.107 1.832l-2.884 5.48a.937.937 0 1 1-1.66-.874l2.402-4.563H21.52a1.25 1.25 0 0 1-1.105-1.835l2.57-4.854a.938.938 0 0 1 1.267-.39Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#474E5A',
      d: 'M15.592 5.093a.938.938 0 0 1 .799-.008l7.5 3.438a.937.937 0 1 1-.782 1.704L16.01 6.974 7.875 10.9v.974h10c.053 0 .105.004.156.013a.937.937 0 0 1 1.094.925v7.5a.937.937 0 1 1-1.875 0V13.75h-2.5v6.563a.937.937 0 1 1-1.875 0V13.75H11v6.563c0 .355-.2.68-.518.838l-2.607 1.303v.671h10.313a.937.937 0 1 1 0 1.875H7.25C6.56 25 6 24.44 6 23.75v-1.682c0-.473.268-.906.691-1.118l2.434-1.217V13.75H7.25c-.69 0-1.25-.56-1.25-1.25v-1.991c0-.48.275-.917.707-1.126l8.885-4.29Z',
    }),
  );
});
bankLightningSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bankLightning = {
  category: 'brand',
  colorable: false,
  name: 'bankLightning',
  svg: bankLightningSvg,
};
